// extracted by mini-css-extract-plugin
export default {"loading":"LoadingStyle_loading__W2Ulj","loading-loading":"LoadingStyle_loading-loading__h2LoI"};